class Metrica {
  #initStatus;

  constructor() {
    this.sendMetric = this.sendMetric.bind(this);
  }

  init() {
    this.#initStatus = this.#checkMetricaInitialization();
  }

  async #checkMetricaInitialization() {
    new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (window.ym) {
          clearInterval(interval);
          return resolve(true);
        }
      }, 100)
    })
  }

  sendMetric(reachGoalName) {
    if (this.#initStatus) {
      window.ym(89546840, `reachGoal`, reachGoalName);
    }
  }
}

const metrica = new Metrica();
metrica.init();

export {metrica};
